(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wo-pastilles"] && !Shopify.designMode) return;
  try {
    (function () {
    var CARTE = '.wo-carte2, .wo-mega__carte';
    var principale = function (c) { return c.querySelector('.wo-carte2__img:not(.wo-carte2__img--2), .wo-mega__img > img:not(.wo-mega__img2)'); };
    document.addEventListener('mouseover', function (e) {
      var p = e.target.closest && e.target.closest('.wo-pastilles__choix');
      if (!p || !p.dataset.woImg) return;
      var c = p.closest(CARTE), im = c && principale(c);
      if (!im) return;
      if (!im.dataset.woSrc) { im.dataset.woSrc = im.getAttribute('src') || ''; im.dataset.woSrcset = im.getAttribute('srcset') || ''; }
      im.removeAttribute('srcset');
      im.src = p.dataset.woImg;
      c.classList.add('is-variante');
      c.querySelectorAll('.wo-pastilles__choix').forEach(function (x) { x.classList.toggle('is-on', x === p); });
    });
    document.addEventListener('mouseout', function (e) {
      var c = e.target.closest && e.target.closest(CARTE);
      if (!c || (e.relatedTarget && c.contains(e.relatedTarget))) return;
      var im = principale(c);
      if (!im || !im.dataset.woSrc) return;
      im.src = im.dataset.woSrc;
      if (im.dataset.woSrcset) im.setAttribute('srcset', im.dataset.woSrcset);
      c.classList.remove('is-variante');
      c.querySelectorAll('.wo-pastilles__choix.is-on').forEach(function (x) { x.classList.remove('is-on'); });
    });
    document.addEventListener('click', function (e) {
      var p = e.target.closest && e.target.closest('.wo-pastilles__choix');
      if (!p || !p.dataset.woUrl) return;
      e.preventDefault();
      window.location.href = p.dataset.woUrl;
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wo-selecteur"] && !Shopify.designMode) return;
  try {
    /* WarmeON (25/10/2026) : le prix de l'encart (téléphone) recopie le prix du thème, que Shopify met à jour à chaque changement de variante */
  (function () {
    function maj() {
      document.querySelectorAll('[data-wo-prix-encart]').forEach(function (el) {
        var zone = el.closest('.shopify-section') || document;
        var src = Array.prototype.find.call(zone.querySelectorAll('product-price'), function (p) { return !p.closest('variant-picker'); });
        if (!src) return;
        var t = (src.querySelector('.price') || src).textContent.replace(/\s+/g, ' ').trim();
        if (t && el.textContent !== t) el.textContent = t;
      });
    }
    var attente = false;
    new MutationObserver(function () {
      if (attente) return; attente = true;
      requestAnimationFrame(function () { attente = false; maj(); });
    }).observe(document.documentElement, { subtree: true, childList: true, characterData: true });
    if (document.readyState !== 'loading') maj(); else document.addEventListener('DOMContentLoaded', maj);
  })();
  } catch(e) { console.error(e); }
})();

})();
